import { render, staticRenderFns } from "./TrendingCard.vue?vue&type=template&id=61f74393&scoped=true"
import script from "./TrendingCard.vue?vue&type=script&lang=js"
export * from "./TrendingCard.vue?vue&type=script&lang=js"
import style0 from "./TrendingCard.vue?vue&type=style&index=0&id=61f74393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f74393",
  null
  
)

export default component.exports